import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import LatestEpisodes from "./components/LatestEpisodes";
import HotCharacters from "./components/HotCharacters";
import LatestNews from "./components/LatestNews";
import { episodes } from "@/mocks/episodes";
import { characters } from "@/mocks/characters";
import { news } from "@/mocks/news";
import { site } from "@/mocks/site";
import useDocumentMeta from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta({
    title: "美国禁忌4 - 剧集简介与最新资讯",
    description:
      "美国禁忌4网站为您提供该剧集的详细剧情介绍、角色解析及最新动态，帮助您全面了解这一影视作品及相关内容。",
  });

  const stats = [
    { value: "04", label: "季数", icon: "ri-stack-line" },
    { value: String(episodes.length).padStart(2, "0"), label: "剧集章节", icon: "ri-film-line" },
    { value: String(characters.length).padStart(2, "0"), label: "核心角色", icon: "ri-user-star-line" },
    { value: String(news.length).padStart(2, "0"), label: "资讯专题", icon: "ri-newspaper-line" },
  ];

  return (
    <div className="px-4 md:px-10 py-5 md:py-8">
      <HeroCarousel />

      {/* Stats strip */}
      <section aria-label="站点概览" className="mt-6 md:mt-8 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {stats.map((item) => (
          <div
            key={item.label}
            className="flex items-center gap-3 rounded-lg bg-background-100 border border-background-200 px-4 py-4"
          >
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500/12 text-accent-400">
              <i className={`${item.icon} text-xl`} />
            </span>
            <div>
              <p className="font-heading text-xl md:text-2xl text-foreground-950 leading-none">{item.value}</p>
              <p className="mt-1 text-xs text-foreground-500 font-label tracking-wide">{item.label}</p>
            </div>
          </div>
        ))}
      </section>

      <LatestEpisodes />
      <HotCharacters />
      <LatestNews />

      {/* Site intro band */}
      <section aria-label="关于本站" className="mt-12 md:mt-16">
        <div className="rounded-lg bg-primary-950 border border-primary-900/60 p-6 md:p-10 grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-8 items-center">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-6 h-[2px] bg-accent-500 inline-block" />
              <span className="font-label tracking-[0.2em] text-xs uppercase text-accent-400">About This Site</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 tracking-wide">
              {site.name} · 剧集专题内容站
            </h2>
            <p className="mt-4 text-sm md:text-[15px] text-primary-200 leading-relaxed max-w-2xl">{site.intro}</p>
            <p className="mt-3 text-sm text-primary-300 leading-relaxed max-w-2xl">{site.footerNote}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-label text-primary-950 hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解本站
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/news"
                className="inline-flex items-center gap-2 rounded-md border border-primary-800 px-5 py-2.5 text-sm font-label text-foreground-900 hover:bg-primary-900/50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-newspaper-line" />
                浏览资讯
              </Link>
            </div>
          </div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3">
            {[
              { icon: "ri-book-open-line", text: "四季剧情脉络系统梳理" },
              { icon: "ri-team-line", text: "核心角色关系网络解析" },
              { icon: "ri-flashlight-line", text: "剧集动态与官方消息同步" },
              { icon: "ri-search-eye-line", text: "全站内容分类检索" },
            ].map((item) => (
              <li
                key={item.text}
                className="flex items-center gap-3 rounded-md bg-primary-900/40 border border-primary-800/60 px-4 py-3"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-400">
                  <i className={`${item.icon} text-base`} />
                </span>
                <span className="text-sm text-primary-100">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}